module.exports = __webpack_public_path__ + "img/vector-left.2869c1bb.svg";